const postImageUploadMaxBytes = 10 * 1024 * 1024;
export const postImageContentTypes = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/gif",
] as const;

export function validatePostImage(file: File): string | null {
  if (!postImageContentTypes.some((type) => type === file.type)) {
    return "Choose a JPG, PNG, WebP, or GIF image.";
  }

  if (file.size > postImageUploadMaxBytes) {
    return "Image is too large. Maximum size is 10MB.";
  }

  return null;
}
